import React from 'react'

function ShippingReturns() {
  return (
    <section>
      <h1 className='text-center'>Shipping Returns</h1>
    </section>
  )
}

export default ShippingReturns
